export default __webpack_public_path__ + "static/media/bx_bxl-youtube.5fbddc87.svg";